import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-background">
        <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground mb-2">Privacy Policy</h1>
            <p className="text-sm sm:text-base text-muted-foreground mb-6 sm:mb-8">Last updated: December 23, 2024</p>

            <div className="space-y-4 sm:space-y-6 lg:space-y-8">
              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">1. Information We Collect</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-3 sm:mb-4">
                KIREETI SOFT TECHNOLOGIES LIMITED. collects information you provide directly to us when using Pharmasoft CS Director, including:
                </p>
                <ul className="list-disc list-inside text-sm sm:text-base text-muted-foreground space-y-1.5 sm:space-y-2">
                  <li>Name and email address</li>
                  <li>Billing and payment information</li>
                  <li>Account preferences and settings</li>
                  <li>Communications with our support team</li>
                </ul>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">2. How We Use Your Information</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-3 sm:mb-4">We use the information we collect to:</p>
                <ul className="list-disc list-inside text-sm sm:text-base text-muted-foreground space-y-1.5 sm:space-y-2">
                  <li>Provide, maintain, and improve Pharmasoft CS Director services</li>
                  <li>Process transactions and send related information</li>
                  <li>Send technical notices and support messages</li>
                  <li>Respond to your comments and questions</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">3. Information Sharing</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as necessary to provide our
                  services (such as payment processing) or as required by law.
                </p>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">4. Data Security</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. All
                  payment information is encrypted using SSL technology.
                </p>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">5. Cookies and Tracking</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  We use cookies and similar tracking technologies to track activity on our service and hold certain information. You can instruct your browser to refuse
                  all cookies or to indicate when a cookie is being sent.
                </p>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">6. Your Rights</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-3 sm:mb-4">You have the right to:</p>
                <ul className="list-disc list-inside text-sm sm:text-base text-muted-foreground space-y-1.5 sm:space-y-2">
                  <li>Access your personal data</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Data portability</li>
                </ul>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">7. Contact Us</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  If you have any questions about this Privacy Policy, please{" "}
                  <Link to="/contact" className="text-primary hover:underline">
                    contact us
                  </Link>
                  .
                </p>
              </section>
            </div>
          </div>
        </main>

        <footer className="border-t border-border mt-8 sm:mt-12 lg:mt-16 py-6 sm:py-8">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm text-muted-foreground">
              <Link to="/about" className="hover:text-foreground transition-colors">
                About Us
              </Link>
              <Link to="/terms" className="hover:text-foreground transition-colors">
                Terms &amp; Conditions
              </Link>
              <Link to="/privacy" className="hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="/refund" className="hover:text-foreground transition-colors">
                Refund &amp; Cancellation
              </Link>
              <Link to="/contact" className="hover:text-foreground transition-colors">
                Contact Us
              </Link>
            </div>
            <p className="text-center text-sm text-muted-foreground mt-4">
              © {new Date().getFullYear()}{" "}
              <a
                href="https://kireetisoft.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground transition-colors underline"
              >
                KIREETI SOFT TECHNOLOGIES LIMITED.
              </a>{" "}
              All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </Layout>
  );
};

export default Privacy;

